/**
 * Вход TikTok или Threads в попапе — один путь для сотрудника и партнёра.
 *
 * Окно открывается сразу по клику — после ожидания адреса браузер счёл бы его
 * непрошеным и заблокировал. Адрес — готовый (сотрудник: бэкенд редиректит
 * сам) или запрашивается уже при открытом окне (партнёр: id в подписанном state).
 *
 * Возврат идёт на адрес из кабинета TikTok/Meta, а он один на оба домена
 * сайта: на другом домене сообщение от окна не дойдёт. Поэтому закрытое окно —
 * тоже конец входа (PopupLoginClosed): вызывающий перечитывает список и
 * смотрит, что вышло.
 */

import { openLoginPopup } from '../../../shared/lib/loginPopup';

export type PopupNetwork = 'tiktok' | 'threads';

export const POPUP_NETWORK_LABEL: Record<PopupNetwork, string> = { tiktok: 'TikTok', threads: 'Threads' };

/** Окно закрыто без сообщения о результате — молча, как у Instagram. */
export class PopupLoginClosed extends Error {
  constructor() { super('Окно входа закрыто'); }
}

export const POPUP_BLOCKED = 'Браузер заблокировал всплывающее окно. Разрешите попапы для этого сайта.';

/** Сотрудник: бэкенд сам строит адрес входа и меняет код на токен. */
export const STAFF_AUTH_URL: Record<PopupNetwork, string> = {
  tiktok: '/api/tiktok/auth',
  threads: '/api/threads/auth',
};

/** Имя подключённого аккаунта (если окно успело сказать). */
export async function popupLogin(
  network: PopupNetwork,
  url: string | (() => Promise<string>),
): Promise<{ name: string | null }> {
  const popup = openLoginPopup(typeof url === 'string' ? url : '', `${network}-auth`);
  if (!popup) throw new Error(POPUP_BLOCKED);
  if (typeof url !== 'string') {
    try {
      popup.location.href = await url();
    } catch (err) {
      popup.close();
      throw err;
    }
  }
  return new Promise((resolve, reject) => {
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      const type = event.data?.type;
      if (type !== `${network}_oauth_success` && type !== `${network}_oauth_error`) return;
      stop();
      if (type === `${network}_oauth_error`) {
        reject(new Error(event.data.error || `Не удалось подключить ${POPUP_NETWORK_LABEL[network]}`));
      } else {
        resolve({ name: event.data.name || null });
      }
    };
    const timer = setInterval(() => {
      if (!popup.closed) return;
      stop();
      reject(new PopupLoginClosed());
    }, 500);
    const stop = () => {
      clearInterval(timer);
      window.removeEventListener('message', onMessage);
    };
    window.addEventListener('message', onMessage);
  });
}
